import {Assert} from "common/Assert";

export function createScormApiForWbt( course ) {

    Assert.checkArgument( course );

    // revealing public api
    return {

        LMSInitialize: () => course.hasActiveLearningSco() ? "true" : "false",
        LMSFinish: () => {
            course.terminateActiveLearningSco();
            return "true";
        },
        LMSGetValue: (key) => {

            const activeSco = course.getActiveLearningSco();
            if (!activeSco) {
                return "false";
            }

            switch (key) {
                case "cmi.core.entry":
                    return "ab-initio";
                case "cmi.core.lesson_location":
                case "cmi.core.lesson_status":
                case "cmi.core.lesson_mode":
                case "cmi.core.score.raw":
                case "cmi.suspend_data":
                    return activeSco.getValue(key);
                default:
                    return course.getValue(key);
            }
        },
        LMSSetValue: (key, value) => {

            const activeSco = course.getActiveLearningSco();
            if (!activeSco) {
                return "false";
            }

            switch (key) {
                case "cmi.core.lesson_location":
                case "cmi.core.lesson_status":
                case "cmi.core.entry":
                case "cmi.core.session_time":
                case "cmi.suspend_data":
                    activeSco.setValue(key, value);
                    return "true";
                case "cmi.core.score.raw":
                    activeSco.updateScore(value);
                    return "true";
                default:
                    return course.setValue(key, value);
            }
        },
        LMSCommit: () => course.hasActiveLearningSco() ? "true" : "false",
        LMSGetLastError: () => "0",
        LMSGetErrorString: () => "",
        LMSGetDiagnostic: () => ""
    };
}
